import React, { useRef, useState } from "react";
import Styles from "../../styles/session/createsession.module.scss";
import Navbar from "../../components/Navbar";
import "react-quill/dist/quill.snow.css";
import ReactQuill from "react-quill";
import "../../styles/session/quill-custom.css";
import { Link, useNavigate } from "react-router-dom";
import { adminRoutes } from "../../routers/AdminRouters";
import { addSession } from "../../services";
import Close_Button from "../../assets/auth/close.png";
import Suceess from "../../assets/session/success.png";
import Swal from "sweetalert2";
import { useSelector, useDispatch } from "react-redux";
import { toggle } from "../../redux";
import { toast, ToastContainer } from "react-toastify";
function hhmmssToSeconds(time) {
  const [hours, minutes, seconds] = time.split(":").map(Number);
  return hours * 3600 + minutes * 60 + seconds;
}
const CreateSession = () => {
  const sessionName = useRef();
  const isSidebarOpen = useSelector((state) => state.navbar.button);
  const dispatch = useDispatch();
  const hoursRef = useRef(null);
  const minutesRef = useRef(null);
  const secondsRef = useRef(null);
  const [secondPagePreview, setSecondPagePreview] = useState("");
  const [thankYouPagePreview, setThankYouPagePreview] = useState("");
  const [warmUp, setWarmUp] = useState();
  const navigate = useNavigate();
  const handleSecondPageChange = (value) => {
    setSecondPagePreview(value);
  };
  const handleMainContainerClick = () => {
    if (isSidebarOpen) {
      dispatch(toggle());
    }
  };
  const handleTimeChange = () => {
    const hours = hoursRef.current.value.padStart(2, "0");
    const minutes = minutesRef.current.value.padStart(2, "0");
    const seconds = secondsRef.current.value.padStart(2, "0");
    setWarmUp(hhmmssToSeconds(`${hours}:${minutes}:${seconds}`));
  };
  const handleThankYouPageChange = (value) => {
    setThankYouPagePreview(value);
  };
  const handleSubmit = async () => {
    // Validate Session Name
    if (sessionName.current.value.trim().length < 3) {
      toast.error("Session name must be at least 3 characters long.");
      return;
    }

    // Validate Warm-Up Time
    if (!warmUp || warmUp <= 0) {
      toast.error("Please enter a valid Warm-Up time.");
      return false;
    }

    // Validate Second Page Preview
    if (!secondPagePreview.trim()) {
      toast.error("Please enter details for the Second Page Preview.");
      return false;
    }

    // Validate Thank You Page Preview
    if (!thankYouPagePreview.trim()) {
      toast.error("Please enter details for the Thank You Page Preview.");
      return false;
    }

    try {
      const formData = new FormData();
      formData.append("name", sessionName.current.value);
      formData.append("details", secondPagePreview);
      formData.append("thankyou", thankYouPagePreview);

      const resp = await addSession(
        sessionName.current.value,
        secondPagePreview,
        thankYouPagePreview,
        warmUp,
      );

      if (resp) {
        Swal.fire({
          html: `
            <div style="text-align: center; border-radius: 20px; position: relative;">
             <button 
                id="customCloseButton" 
                style="position: absolute; top:-10px; right:-20px; background: none; border: none; cursor: pointer;">
                <img 
                src=${Close_Button} 
                  alt="Close" 
                  style="width: 50px; height: 50px;"
                />
              </button>
              <img 
                src=${Suceess} 
                alt="Success" 
                style="width: 100px; margin-bottom: 20px;margin-top:30px;" 
              />
             
              
            <p style="color: #151515; text-align:center; font-family:gothambold; font-size:24px;">
               Sessions Successfully Created
              </p>
              <button 
                id="assignformat" 
                style="background: linear-gradient(0deg, #151515 0%, #525252 100%); color: #f3f3f6; padding: 15px 20px; font-family:gothambold; border: none; border-radius: 8px; cursor: pointer; margin-top: 20px;width:250px;height:48px;">
Assign Format            
  </button>
  <br/>
            <button 
                id="later" 
  style="background: white; color: #151515;  padding: 15px 20px; font-family:gothambold; border-radius: 8px; cursor: pointer; margin-top: 20px;border: 1px solid #E27808;width:250px;height:48px;font-size:14px;">
Later  </button>
            </div>
          `,
          showConfirmButton: false,
          customClass: {
            popup: "custom-swal-container",
          },
          didOpen: () => {
            const assignformat = document.getElementById("assignformat");
            const later = document.getElementById("later");
            const closeButton = document.getElementById("customCloseButton");

            assignformat.addEventListener("click", () => {
              Swal.close();
              navigate(
                `${adminRoutes.assignFormatFirst.replace(
                  ":sessionId",
                  resp._id,
                )}`,
              );
            });

            later.addEventListener("click", () => {
              Swal.close();
              navigate(adminRoutes.listSession);
            });

            closeButton.addEventListener("click", () => {
              Swal.close();
              navigate(adminRoutes.listSession);
            });
          },
        });
      }
    } catch (error) {
      console.error("Error submitting client:", error);
    }
  };
  const handleBack = () => {
    navigate(adminRoutes.listSession);
  };
  return (
    <>
      <Navbar />
      <ToastContainer />

      <div
        className={Styles.createsession_main}
        onClick={handleMainContainerClick}
      >
        <h2>
          <Link to={adminRoutes.dashboard} className={Styles.dark}>
            HOME /
          </Link>{" "}
          <Link to={adminRoutes.listSession} className={Styles.white}>
            ALL SESSIONS /
          </Link>{" "}
          <span className={Styles.orange}>NEW SESSIONS</span>
        </h2>
        <div className={Styles.createsession_container}>
          <div className={Styles.createsession}>
            <div className={Styles.createsession_container_heading}>
              <h3>CREATE NEW SESSION</h3>
            </div>
            <hr />
            <div className={Styles.createsession_form_container}>
              <form autoComplete="">
                <div className={Styles.createsession_form}>
                  <div className={Styles.createsession_form_containerone}>
                    <label className={Styles.label}>Session Name</label>
                    <input
                      placeholder="Enter here"
                      required
                      type="text"
                      name="sessionname"
                      ref={sessionName}
                    />
                  </div>
                  <div className={Styles.createsession_form_containertwo}>
                    <label className={Styles.label}>Warm Up</label>
                    <div className={Styles.time_field}>
                      <span className={Styles.icon}>
                        <svg
                          width="25"
                          height="25"
                          viewBox="0 0 25 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.333 22C17.8559 22 22.333 17.5228 22.333 12C22.333 6.47715 17.8559 2 12.333 2C6.81016 2 2.33301 6.47715 2.33301 12C2.33301 17.5228 6.81016 22 12.333 22Z"
                            stroke="#808080"
                            stroke-width="1.5"
                          />
                          <path
                            d="M12.333 8V12L14.333 14"
                            stroke="#808080"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </span>
                      <input
                        type="text"
                        placeholder="00"
                        minLength={1}
                        min={1}
                        max={2}
                        maxLength={2}
                        className={Styles.time_input}
                        ref={hoursRef}
                        onChange={handleTimeChange}
                        onKeyDown={(e) => {
                          if (e.key === "-") {
                            e.preventDefault();
                          }
                        }}
                      />
                      <span className={Styles.separator}>:</span>
                      <input
                        type="text"
                        placeholder="00"
                        minLength={1}
                        maxLength={2}
                        min={1}
                        max={2}
                        className={Styles.time_input}
                        ref={minutesRef}
                        onChange={handleTimeChange}
                        onKeyDown={(e) => {
                          if (e.key === "-") {
                            e.preventDefault();
                          }
                        }}
                      />
                      <span className={Styles.separator}>:</span>
                      <input
                        type="text"
                        placeholder="00"
                        minLength={1}
                        maxLength={2}
                        min={1}
                        max={2}
                        className={Styles.time_input}
                        ref={secondsRef}
                        onChange={handleTimeChange}
                        onKeyDown={(e) => {
                          if (e.key === "-") {
                            e.preventDefault();
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div className={Styles.createsession_form_containertwo}>
                    <label className={Styles.label}>
                      Second Page Preview Details
                    </label>
                    <div className="first-quill">
                      <ReactQuill
                        theme="snow"
                        placeholder="Enter here..."
                        value={secondPagePreview}
                        onChange={handleSecondPageChange}
                        className={Styles.customQuill}
                      />
                    </div>
                  </div>
                </div>

                <div className={Styles.createsession_form_containerright}>
                  <label className={Styles.label}>
                    Thank You Page Preview Details
                  </label>
                  <div className="second-quill">
                    <ReactQuill
                      theme="snow"
                      placeholder="Enter here..."
                      value={thankYouPagePreview}
                      onChange={handleThankYouPageChange}
                      className={Styles.customQuill}
                    />
                  </div>
                </div>
              </form>
            </div>
            <hr />
            <div className={Styles.button_container}>
              <div
                className={Styles.save}
                onClick={handleSubmit}
                style={{ cursor: "pointer" }}
              >
                Save
              </div>
              <div
                className={Styles.cancel}
                onClick={handleBack}
                style={{ cursor: "pointer" }}
              >
                Cancel
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateSession;
